import React from 'react';
import styles from '../header-bar-styles';

export default function HeaderMenus(props) {
    return React.createElement(
        'div',
        { style: styles.menusWrap },
        props.children
    );
}


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/app-header/menus/HeaderMenus.js
// module id = 525
// module chunks = 13